import React from 'react'
import { Form } from 'react-bootstrap'

interface GroupCheckboxProps {
  options: string[]
  selectedOptions: string[]
  onToggle: (options: string[], allEnabled: boolean) => void
  disabled?: boolean
}

export const GroupCheckbox: React.FC<GroupCheckboxProps> = ({ options, selectedOptions, onToggle, disabled }) => {
  const selectedSet = new Set(selectedOptions)
  const enabledInGroup = options.filter((e) => selectedSet.has(e))
  const allEnabled = enabledInGroup.length === options.length
  const someEnabled = enabledInGroup.length > 0 && !allEnabled

  return (
    <Form.Check
      className='d-flex align-items-center'
      ref={(el) => {
        if (el) el.indeterminate = someEnabled
      }}
      type='checkbox'
      checked={allEnabled}
      onChange={() => onToggle(options, allEnabled)}
      disabled={disabled}
    />
  )
}
